import React, {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {SeoHead} from '../../modules/seo'

const DemoPage: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/demo/intro-video')
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className='demo-page-container'>
      <SeoHead />
      <img
        src='/media/logos/shipbae-logo-black.svg'
        alt='ShipBae Powered By Gori.ai'
        className='img-fluid p-10 p-m-0 demo-page-logo'
      />
    </div>
  )
}

export default DemoPage
